import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Translator, TRANSLATOR } from '@miq/utils';
import { DigitalAssistantComponent } from '../digital-assistant.component';
import { ChatBotOverlayService } from '../components/chat/services/chat-bot-overlay.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { OverlayModule } from '@angular/cdk/overlay';
import { PositionType } from '../components/chat/services/chat-bot-overlay.helper';
import { CbreLogger, CbreLoggerToken } from '@cbre/logger';

@UntilDestroy()
@Component({
  selector: 'miq-digital-assistant-button',
  imports: [CommonModule, MatIconModule, MatTooltipModule, OverlayModule],
  providers: [ChatBotOverlayService],
  template: `
    <div
      class="chat-bot-assistant"
      #chatBtn
      [ngClass]="{ 'chat-bot-assistant--open': chatBotOverlayService.isChatBotOpen() }"
      matTooltipClass="tooltip-action-icon__how-to-videos"
      [matTooltip]="chatBotToolTip"
      (click)="openChatWindow(chatBtn)"
    >
      <ng-container *ngIf="chatBotOverlayService.isChatBotOpen()">
        <span class="chat-bot-icon expand-more"> <ng-content select="[chatOpen]"></ng-content></span>
      </ng-container>
      <ng-container *ngIf="!chatBotOverlayService.isChatBotOpen()">
        <mat-icon class="chat-bot-icon" svgIcon="ellis-ai-avatar"></mat-icon>
      </ng-container>
    </div>
  `,
  styleUrls: ['./digital-assistant-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DigitalAssistantButtonComponent {
  @Input() userInfo: Record<string, any> = {};
  @Input() overlayPosition: PositionType = 'below';
  public chatBotToolTip: string;

  constructor(
    @Inject(TRANSLATOR) translation: Translator,
    public chatBotOverlayService: ChatBotOverlayService,
    @Inject(CbreLoggerToken) private logger: CbreLogger
  ) {
    this.chatBotToolTip = translation.translate('admin.digitalAssistant');
  }

  openChatWindow(btnEl: HTMLElement): void {
    const { componentRef } = this.chatBotOverlayService.openChat(
      btnEl,
      DigitalAssistantComponent,
      this.overlayPosition
    );
    componentRef.userInfo = this.userInfo;
    componentRef.emitCloseChat.pipe(untilDestroyed(this)).subscribe({
      next: () => this.destroyChatWindow(componentRef),
      error: (err: any) => this.logger.error(`Error in emitCloseChat subscription: ${err}`),
    });
  }

  private destroyChatWindow(componentRef): void {
    if (componentRef) {
      this.chatBotOverlayService.closeChat();
    }
  }
}
